
import { OktaAuth } from '@okta/okta-auth-js'
import { serverURL } from '../config';
// const OKTA_CLIENT_ID = '0oa3j1slfnUc5VMuh697'; // is this for the tiral org only?
export const OKTA_CALLBACK_URL = `${serverURL}/auth/callback`;

export const SSO_ORG_DOMAINS = [
  'motorwerks.com'
]

export const oktaOrgs = [
  { orgID: '634efb73c2586821a8cab574', name: 'Motor Werks' },
  { orgID: '6342cc9e1765f9c0c424f807', name: 'DoorDash' },
  { orgID: '634ed3ad30be5b837cc3be74', name: 'Uber' },
];

export const issOrgMapping = {
  'https://trial-7297036.okta.com': "634ed3ad30be5b837cc3be74", // prod
  // 'https://trial-7297036.okta.com': "6342cc9e1765f9c0c424f807", // dev
  'https://auth.motorwerks.com': "634efb73c2586821a8cab574",
  'https://motorwerks.okta.com': "634efb73c2586821a8cab574"
};

export const oktaConfigMap = {
  '634efb73c2586821a8cab574': { // MW
    issuer: 'https://motorwerks.okta.com', // not sure if MW requires /oauth2/default ending
    // issuer: process.env.NEXT_PUBLIC_MW_OKTA_URL + '/oauth2/default', // not sure if MW requires /oauth2/default ending
    oktaKeyPath: 'MW_OKTA_KEY',
    oktaUrl: 'https://motorwerks.okta.com',
    oktaClientID: '0oa3j9uuvd7dEkuOq697',
    magicProviderID: 'mqFQhSqQNwZE9VQXclhgjPK0mCAMUxBPS97zaMYVgDU=',
  },
  '6342cc9e1765f9c0c424f807': { // SS Dev (DoorDash)
    issuer: 'https://trial-7297036.okta.com' + '/oauth2/default',
    oktaKeyPath: 'TRIAL_OKTA_KEY',
    oktaUrl: 'https://trial-7297036.okta.com',
    oktaClientID: '0oa3j1slfnUc5VMuh697',
    magicProviderID: 'mjIjPjLsuKVixdos40R_W5wzcDsz6rMlf3lhKd-c0wQ=',
  },
  '634ed3ad30be5b837cc3be74': { // SS Prod (Uber)
    issuer: 'https://trial-7297036.okta.com' + '/oauth2/default',
    oktaKeyPath: 'TRIAL_OKTA_KEY',
    oktaUrl: 'https://trial-7297036.okta.com',
    oktaClientID: '0oa3j1slfnUc5VMuh697',
    magicProviderID: 'mjIjPjLsuKVixdos40R_W5wzcDsz6rMlf3lhKd-c0wQ=',
  },
}


const createOktaClient = (orgID) => {
  const orgOktaConfig = oktaConfigMap[orgID];

  var config = {
    issuer: orgOktaConfig.issuer,
    clientId: orgOktaConfig.oktaClientID,
    // issuer: process.env.TRIAL_OKTA_URL + '/oauth2/default',
    // clientId: OKTA_CLIENT_ID,
    redirectUri: OKTA_CALLBACK_URL,
  };
  const oktaClient = new OktaAuth(config);
  return oktaClient;
}


export default createOktaClient;





// import { OktaAuth } from '@okta/okta-auth-js'
// import { serverURL } from '../config';
// const OKTA_CLIENT_ID = '0oa3j1slfnUc5VMuh697';
// export const OKTA_CALLBACK_URL = `${serverURL}/auth/callback`;

// export const oktaOrgs = [{ orgID: '6342cc9e1765f9c0c424f807', name: 'MotoWerks' }];

// var config = {
//   issuer: process.env.TRIAL_OKTA_URL + '/oauth2/default',
//   clientId: OKTA_CLIENT_ID,
//   redirectUri: OKTA_CALLBACK_URL,
// };

// const OktaClient = new OktaAuth(config);

// export default OktaClient